import {CocinaFiltros} from '@app/state/restaurant/cocina/cocina-restaurante.state';

export class SetFiltros {
    static readonly type = '[CocinaRestaurant] SetFiltros';

    constructor(public filtros: Partial<CocinaFiltros>) {
    }
}
